module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/175/assets/images/a0e217ad4d6373bd441936e6737d2909.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_close_active.svg
// module id = yG5+
// module chunks = 1